import React from 'react';
import { getRbiRefundInfoWidgetData, getRbiExistingCouponsInfo } from '../../../../../selectors/tools';
import { useSelector } from 'react-redux';
import {
  ResultsColumn,
  ResultsColumnHeader,
  Row,
  HeaderRow,
  SubTitleText,
  Spreadsheet,
} from '../../DTInfoWidget.styles';

const DTRbiCouponInfoWidget = () => {
  const { customerName, storeAddress, deliveryStatus, couponType } = useSelector(getRbiRefundInfoWidgetData);
  const { redeemedCoupons, assignedCoupons } = useSelector(getRbiExistingCouponsInfo);

  return (
    <>
      <Spreadsheet className="fs-block">
        <HeaderRow>
          <ResultsColumnHeader>CUSTOMER NAME</ResultsColumnHeader>
          <ResultsColumnHeader>STORE ADDRESS</ResultsColumnHeader>
          <ResultsColumnHeader>DELIVERY STATUS</ResultsColumnHeader>
          {!!couponType && <ResultsColumnHeader>COUPON TYPE</ResultsColumnHeader>}
        </HeaderRow>
        <Row>
          <ResultsColumn>{customerName}</ResultsColumn>
          <ResultsColumn>{storeAddress}</ResultsColumn>
          <ResultsColumn>{deliveryStatus}</ResultsColumn>
          {!!couponType && <ResultsColumn>{couponType}</ResultsColumn>}
        </Row>
      </Spreadsheet>
      {!!redeemedCoupons.length && (
        <>
          <SubTitleText style={{ marginTop: '15px' }}>REDEEMED COUPONS</SubTitleText>
          <HeaderRow>
            <ResultsColumnHeader>NAME</ResultsColumnHeader>
            <ResultsColumnHeader>ASSIGNED AT</ResultsColumnHeader>
            <ResultsColumnHeader>REDEEMED ON</ResultsColumnHeader>
            <ResultsColumnHeader>ISSUED BY</ResultsColumnHeader>
          </HeaderRow>
          {redeemedCoupons.map((offer) => (
            <Row className="fs-block" key={offer.tokenId}>
              <ResultsColumn>{offer.name}</ResultsColumn>
              <ResultsColumn>{offer.assignedAt}</ResultsColumn>
              <ResultsColumn>{offer.redeemedOn}</ResultsColumn>
              <ResultsColumn>{offer.issuedBy}</ResultsColumn>
            </Row>
          ))}
        </>
      )}
      {!!assignedCoupons.length && (
        <>
          <SubTitleText style={{ marginTop: '15px' }}>ASSIGNED COUPONS</SubTitleText>
          <HeaderRow>
            <ResultsColumnHeader>NAME</ResultsColumnHeader>
            <ResultsColumnHeader>CREATED AT</ResultsColumnHeader>
            <ResultsColumnHeader>EXPIRES AT</ResultsColumnHeader>
            <ResultsColumnHeader>ISSUED BY</ResultsColumnHeader>
          </HeaderRow>
          {assignedCoupons.map((offer) => (
            <Row className="fs-block" key={offer.tokenId}>
              <ResultsColumn>{offer.name}</ResultsColumn>
              <ResultsColumn>{offer.createdAt}</ResultsColumn>
              <ResultsColumn>{offer.expiresAt}</ResultsColumn>
              <ResultsColumn>{offer.issuedBy}</ResultsColumn>
            </Row>
          ))}
        </>
      )}
    </>
  );
};
export default DTRbiCouponInfoWidget;
